export default __webpack_public_path__ + "static/media/data.85314e08.svg";